import { apiClient } from '@/lib/api/client'
import type { Category } from '@/types'

export const getCategories = async (): Promise<Category[]> => {
  const { data } = await apiClient.get('/api/categories/')
  return data
}
